import { Element, Icon } from 'react-bulma-components';
import { FaRegFolderOpen } from 'react-icons/fa6';

export type DefaultInboxTableProps = {
  text: string;
};

export function DefaultInboxTable({ text }: DefaultInboxTableProps) {
  return (
    <Element
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      className="h-full gap-8"
    >
      <Icon className="folder-icon-big">
        <FaRegFolderOpen />
      </Icon>
      <Element textAlign="center">
        <h1 className="is-size-3 has-text-weight-light">
          Nothing to show here
        </h1>
        <h3 className="is-size-5 has-text-weight-light">{text}</h3>
      </Element>
    </Element>
  );
}

export default DefaultInboxTable;
